module.exports = __webpack_public_path__ + "static/media/hotel-x-logo.5c548be9.png";